import styled from "styled-components/macro";

export const CustomizeEntityDefaultsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;

  .trait-customization-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 16px);
    margin-top: 36px;
    padding: 0px 8px;
    .reset-defaults {
      .text-button-inner {
        svg {
          margin-right: 2px;
          margin-left: -2px;
        }
      }
    }
    .delete-defaults {
      .text-button-inner {
        svg {
          margin-left: -2px;
          path {
            fill: var(--danger-color);
          }
        }
        color: var(--danger-color);
        padding: 8px 12px 8px 10px;
      }
    }
  }

  .role-selector-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--grey-0);
    gap: 10px;
    font-weight: 500;

    .role-selector {
      width: 200px;
      > div:nth-child(2) {
        color: var(--grey-1);
        input,
        textarea {
          color: var(--grey-0) !important;
          caret-color: var(--grey-0);
        }
      }

      > div:focus-within {
        border: 1.5px solid var(--primary-cta);
      }
    }
  }

  ul.trait-list {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 8px 10px 8px;

    li.trait-list-item {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 4px;
      width: 100%;
      /* border: 1.5px solid var(--grey-3); */
      border-radius: 8px;
      padding: 6px 10px;
      box-shadow: var(--reorderable-list-drop-shadow);
      background-color: var(--menu-color-fullscreen);

      .grabber {
        cursor: grab;
      }

      input {
        flex: 1;
        border: 1.5px solid var(--menu-color-fullscreen-outline);
        border-radius: 5px;
        line-height: 1.3;
        padding: 6px 6px;
        color: var(--grey-0);
        font-size: 16px;
        font-weight: 500;
        font-family: "Inter", sans-serif;
        background-color: var(--menu-color-fullscreen);

        &:focus {
          outline: none;
          border: 1.5px solid var(--primary-cta-high-contrast);
        }
      }

      svg {
        path {
          fill: var(--grey-2);
        }
        circle {
          fill: var(--grey-2);
        }
      }
    }
  }
  .feedback-container {
    padding: 10px 0px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    .feedback {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-left: 8px;
      color: var(--grey-0);
    }
  }
`;

export const CustomFooterStyles = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;

  .add-to-current-checkbox {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    user-select: none;
    color: var(--grey-0);
    font-size: 15px;
    font-weight: 500;

    input[type="checkbox"] {
      width: 16px;
      height: 16px;
      accent-color: var(--primary-cta);
      cursor: pointer;
    }

    input[type="checkbox"]:disabled {
      cursor: not-allowed;
    }
  }

  button {
    font-size: 16px;
    background: var(--primary-cta);
    color: var(--cta-text-color);
    border: 0;
    font-family: "Inter";
    font-weight: 500;
    cursor: pointer;
    padding: 9px 14px;
    border-radius: 10px;

    &.disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }
`;
